// import service from '@/api/modules/service_app';
import service from '@/api';
import axios from 'axios';
import { exportFile } from 'quasar';
// import { GlobalStore } from '@/store';
// import axios from 'axios';


// import dummy_inform from './dummy/study_inform.json';
// const timeout = () => new Promise((resolve) => setTimeout(resolve, 500));
/*********회원정보************************************************/
/**  회원정보 조회  */
export const getUserInfo = async (token) => {
    try {
        const res = await service({
            url: `/api/user/info`,
            method: 'get',
            headers: { Authorization: `Bearer ${token}` },
        });
        // console.log('--getUserInfo-DATA:', res);
        return res;
    } catch (e) {
        return e.response ? e.response : null;
    }
};

/** * 비밀번호 확인  */
export const checkPw = async (token, pw) => {
    try {
        const res = await service({
            url: `/api/my-page/password/check`,
            method: 'get',
            params: { password: pw },
            headers: { Authorization: `Bearer ${token}` },
        });
        return res;
    } catch (e) {
        return e.response ? e.response : null;
    }
};
/** * 비밀번호 변경  */
export const updatePw = async (token, pw) => {
    try {
        const res = await service({
            url: `/api/my-page/password/update`,
            method: 'post',
            data: { password: pw },
            headers: { Authorization: `Bearer ${token}` },
        });
        // console.log('--updatePw-DATA:', res);
        return res;
    } catch (e) {
        return e.response ? e.response : null;
    }
};

/**  * 효과음 설정 */
export const setSoundSwitch = async (token, isOn) => {
    try {
        const res = await service({
            url: `/api/my-page/sound/update-status`,
            method: 'post',
            data: { soundFlag: isOn },
            headers: { Authorization: `Bearer ${token}` },
        });
        // console.log('--setSoundSwitch-DATA:', res);
        return res;
    } catch (e) {
        return e.response ? e.response : null;
    }
};


/**  * 학습 알림 리스트 가져오기   */
let i = 0;
export const getStudyInformList = async (token, pageNo, wPeriod) => {
    // await timeout();
    // i++;
    // if (i < 3) return dummy_inform;
    // else return [];

    try {
        const res = await service({
            url: `/api/my-page/message/list/${pageNo}`,
            method: 'get',
            params: { period: wPeriod },
            headers: { Authorization: `Bearer ${token}` },
        });
        // console.log('--getStudyInformList-DATA:', res);
        return res;
    } catch (e) {
        return e.response ? e.response : null;
    }
};

/*******앱정보******************************************************/
/**  * 공지사항 list 가져오기  */
export const getNoticeList = async (pageNo, wPeriod) => {
    try {
        const res = await service({
            url: `/api/my-page/notice/list/${pageNo}`,
            method: 'get',
            params: { period: wPeriod },
        });
        return res;
    } catch (e) {
        return e.response ? e.response : null;
    }
};

/** * 공지사항  가져오기  */
export const getNotice = async (seq) => {
    try {
        const res = await service({
            url: `/api/my-page/notice/view/${seq}`,
            method: 'get',
        });
        return res;
    } catch (e) {
        return e.response ? e.response : null;
    }
};
/** * 공지사항  첨부파일 가져오기  */
export const apiGetNoticeFile = async (fileName, fileSeq) => {
    const serviceFile = axios.create({
        withCredentials: true,
        timeout: 1000 * 5,
        baseURL: process.env.VUE_APP_API_URL,
    });

    try {
        const res = await serviceFile({
            url: `/api/my-page/notice/file-download/${fileSeq}`,
            method: 'get',
            responseType: 'blob',
        });
        const status = exportFile(fileName, res.data);
        return status;
        // return res;
    } catch (e) {
        return e.response ? e.response : null;
    }
};



/** * 개인정보 처리방침 리스트 가져오기   */
export const getPrivateList = async () => {
    // await timeout();
    // i++;
    // if (i < 3) return dummyNotice;
    // else return [];
    try {
        const res = await service({
            url: '/api/my-page/privacy-policy/list',
            method: 'get',
        });
        return res;
    } catch (e) {
        return e.response ? e.response : null;
    }
};

/** * 이용약관 리스트  */
export const getTermsList = async () => {
    try {
        const res = await service({
            url: '/api/my-page/term/list',
            method: 'get',
        });
        return res;
    } catch (e) {
        return e.response ? e.response : null;
    }
};

/** * 앱 버전  */
export const latestAppVersion = async (mobileOsCode) => {
    try {
        const res = await service({
            url: '/api/my-page/latest-version',
            method: 'get',
            params: { mobileOsCode },
        });
        return res;
    } catch (e) {
        return e.response ? e.response : null;
    }
};
